module.exports = __webpack_public_path__ + "static/media/speed icon.a2f13f57.svg";